<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <router-link
              v-if="$route.meta.rtlActive"
              :to="{ path: '#' }"
              >منزل</router-link
            >
            <a v-else href="#">首 页</a>
          </li>
          <li>
            <router-link
              v-if="$route.meta.rtlActive"
              :to="{ path: '#' }"
              >منزل</router-link
            >
            <a v-else href="#">元学</a>
          </li>
          <li>
            <a v-if="$route.meta.rtlActive" href="#">
              شركة
            </a>
            <a v-else href="#">
              联盟院校
            </a>
          </li>
          <li>
            <a v-if="$route.meta.rtlActive" href="#">
              محفظة
            </a>
            <a v-else href="#"> 服务企业 </a>
          </li>
          <li>
            <a
              v-if="$route.meta.rtlActive"
              href="#/license"
            >
              بلوق
            </a>
            <a v-else href="#/license"> 合作伙伴 </a>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="#/?ref=mdp-vuejs" target="_blank"
          >元学</a
        >
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style scoped>
@media (max-width:600px) {
  .container {
    padding-right: 0px;
    padding-left: 0px;
        text-align: center;
  }
  .copyright {
     margin-right: 35px;
  }
  
}
</style>
